module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0026.jpg?v=9c5b282c";